import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetLastActiveDirectoryGroupsSyncTimeParams {
}

export interface IGetLastActiveDirectoryGroupsSyncTimeResult {
  time: string; // e.g. "2015-05-20T12:00:00.000Z"
}

export class GetLastActiveDirectoryGroupsSyncTimeRequest extends Request<IGetLastActiveDirectoryGroupsSyncTimeParams, IGetLastActiveDirectoryGroupsSyncTimeResult> {
  constructor(params: IGetLastActiveDirectoryGroupsSyncTimeParams = {}) {
    super('getLastActiveDirectoryGroupsSyncTime', params);
  }
}
